<div class="relative min-h-[10rem]">
  @if (userIsLoading()) {
    <korviu-loader />
  } @else if (userNotFound()) {
    <div
      class="flex min-h-[20rem] items-center justify-center px-4 text-center text-xl font-medium text-gray-700"
      data-testid="user-not-found"
    >
      {{ 'my-forest.userNotFound' | translate }}
    </div>
  } @else {
    <workspace-breadcrumb class="block w-full max-w-[60rem] mx-auto" />
    @if (isGanacocio()) {
      <app-my-forest-user-info-special [user]="user()" class="block w-full" />
    } @else {
      <app-my-forest-user-info-default
        [ganamigoGanasShared]="ganamigoGanasShared()"
        [ganasShared]="ganasShared()"
        [isIndirectMember]="isIndirectRegularMember()"
        [user]="user()"
        [userTimeline]="userTimeline()"
        class="block w-full"
      />
    }
  }
</div>
